import { render } from "./NeuroSurgery.vue?vue&type=template&id=28c1de4c&scoped=true"
import script from "./NeuroSurgery.vue?vue&type=script&lang=ts"
export * from "./NeuroSurgery.vue?vue&type=script&lang=ts"

import "./NeuroSurgery.vue?vue&type=style&index=0&id=28c1de4c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-28c1de4c"

export default script